import script from "./DealerTable.vue?vue&type=script&setup=true&lang=js"
export * from "./DealerTable.vue?vue&type=script&setup=true&lang=js"

import "./DealerTable.vue?vue&type=style&index=0&id=b16f2fd0&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b16f2fd0"]])

export default __exports__